import { isProduction } from "fe-common/utils/envGetter";

export const openInEditor = (url: string) => {
  window.open(editorLink(url), "_blank");
};

export const editorLink = (url: string) =>
  `https://editor${isProduction() ? "" : "-dev"}.kahun.com/#/w-kahun/${url}`;
